import React, { useState, useRef, useEffect, useCallback } from 'react';
import { Base64 } from 'js-base64';
import axios from 'axios';
import { GET_PASSENGER_PROFILE_DETAILS } from '../../constant';
import { useLocation, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { setLoading } from '../../redux/loaderAction';
import Loader from '../../components/loader/Loader';
import moment from 'moment';
import DefaultProfileImage from '../../assets/images/default-profile-img.png';
import { currentDateFormat } from "../../utils";
import {
  MDBCol,
  MDBContainer,
  MDBRow,
  MDBCard,
  MDBCardText,
  MDBCardBody,
  MDBCardImage,
  MDBBtn,
  MDBBreadcrumb,
  MDBBreadcrumbItem,
  MDBProgress,
  MDBProgressBar,
  MDBIcon,
  MDBListGroup,
  MDBListGroupItem
} from 'mdb-react-ui-kit';
import { Button } from '@mui/material';

function PassengerProfile() {
  const dispatch = useDispatch();
  const loading = useSelector((state) => state.loader.loading);
  const location = useLocation();
  const navigate = useNavigate();
  const [currentDate, setCurrentDate] = useState(new Date());
  const queryParams = new URLSearchParams(location.search);
  const encodedProfileId = queryParams.get('profilId');
  const profileId = Base64.decode(encodedProfileId);
  const [passengerList, setPassengerList] = useState();
  // {console.log(profileId)}
  useEffect(() => {
    const loadUser = async () => {
      try {
        dispatch(setLoading(true));
        const response = await axios.get(GET_PASSENGER_PROFILE_DETAILS + '/' + `${profileId}`);
        if (response.status === 200) {
          dispatch(setLoading(false));
          setPassengerList(response.data.passenger);
          // Handle the response data as needed
        }
      } catch (error) {
        console.error("Error fetching driver list:", error);
        dispatch(setLoading(false));
      }
    }
    loadUser();
  }, []);



  return (
    <><div className="tab-pane fade active show" id="add-passenger" role="tabpanel" aria-labelledby="home-tab">
      {/* <section>
                <div className='d-flex justify-content-between form-container'>
                    <div>
                        <h2 className="fs-5 font-weight-600">Passenger Profile</h2>
                    </div>
                    <div>
                        <ToastContainer />
                    </div>
                    <div>
                        <span>{currentDateFormat(currentDate)}</span>
                    </div>
                </div>
            </section> */}
      <section>
        <div className='d-flex justify-content-between form-container'>
          <div>
            <h2 className="fs-5 font-weight-600">Passenger Profile </h2>
          </div>
          <div>
            <span>{currentDateFormat(currentDate)}</span>
          </div>
        </div>
      </section>
      <section style={{ backgroundColor: '#eee' }}>
        <MDBContainer className="py-5">


          <MDBRow>
            <MDBCol lg="4">
              <MDBCard className="mb-4">
                <MDBCardBody className="text-center">
                  <a
                    href={`/home/passenger/edit/${passengerList?.passenger?.passenger_id}`}
                    className="position-absolute"
                    style={{
                      top: '10px',
                      right: '10px',
                      textDecoration: 'underline',
                      color: '#31876f',
                      fontWeight: 'bold',
                    }}
                  >
                    Edit
                  </a>
                  <MDBCardImage
                    src={DefaultProfileImage}
                    alt="avatar"
                    className="rounded-circle"
                    style={{ width: '150px' }}
                    fluid />
                  <p className="text-muted mb-1"><h4>{`${passengerList?.passenger_first_name || ''} ${passengerList?.passenger_middle_name || ''} ${passengerList?.passenger_last_name || ''}`}</h4></p>
                  <p className="text-muted mb-1">PMI Number : {passengerList?.passenger?.pass_pmi_no}</p>
                  {
                    passengerList?.passenger?.payerDetails?.payer_name === "MA" ? (<div>
                      <div className="mt-3">
                        <button
                          type="button"
                          className="btn btn-success btn-sm rounded-1"
                          onClick={() => {
                            const passengerName = `${passengerList?.passenger_first_name || ''} ${passengerList?.passenger_middle_name || ''} ${passengerList?.passenger_last_name || ''}`.trim();
                            const passengerId = passengerList?.passenger?.passenger_id;
                            const payerId = passengerList?.passenger?.payerDetails?.id;
                            navigate(`/home/passenger/service-authorization?profilId=${encodedProfileId || ''}`, { state: { passengerName, passengerId, payerId } });
                          }}
                        >
                          Service Authorization List
                        </button>
                      </div>
                    </div>)
                      : null
                  }

                </MDBCardBody>
              </MDBCard>





              <MDBCard className="mb-4 mb-lg-0" style={{ display: 'none' }}>
                <MDBCardBody className="p-0">
                  <MDBListGroup flush className="rounded-3">
                    <MDBListGroupItem className="d-flex justify-content-between align-items-center p-3">
                      <MDBIcon fas icon="globe fa-lg text-warning" />
                      <MDBCardText>https://mdbootstrap.com</MDBCardText>
                    </MDBListGroupItem>
                    <MDBListGroupItem className="d-flex justify-content-between align-items-center p-3">
                      <MDBIcon fab icon="github fa-lg" style={{ color: '#333333' }} />
                      <MDBCardText>mdbootstrap</MDBCardText>
                    </MDBListGroupItem>
                    <MDBListGroupItem className="d-flex justify-content-between align-items-center p-3">
                      <MDBIcon fab icon="twitter fa-lg" style={{ color: '#55acee' }} />
                      <MDBCardText>@mdbootstrap</MDBCardText>
                    </MDBListGroupItem>
                    <MDBListGroupItem className="d-flex justify-content-between align-items-center p-3">
                      <MDBIcon fab icon="instagram fa-lg" style={{ color: '#ac2bac' }} />
                      <MDBCardText>mdbootstrap</MDBCardText>
                    </MDBListGroupItem>
                    <MDBListGroupItem className="d-flex justify-content-between align-items-center p-3">
                      <MDBIcon fab icon="facebook fa-lg" style={{ color: '#3b5998' }} />
                      <MDBCardText>mdbootstrap</MDBCardText>
                    </MDBListGroupItem>
                  </MDBListGroup>
                </MDBCardBody>
              </MDBCard>
            </MDBCol>
            <MDBCol lg="8">
              <MDBCard className="mb-4">
                <MDBCardBody>
                  <p className='sub-title'>Personal Information</p>
                  <hr />
                  <MDBRow>
                    <MDBCol sm="3">
                      <MDBCardText>Full Name</MDBCardText>
                    </MDBCol>
                    <MDBCol sm="9">
                      <MDBCardText className="text-muted">{`${passengerList?.passenger_first_name || ''} ${passengerList?.passenger_middle_name || ''} ${passengerList?.passenger_last_name || ''}`}</MDBCardText>
                    </MDBCol>
                  </MDBRow>
                  <hr />
                  <MDBRow>
                    <MDBCol sm="3">
                      <MDBCardText>Gender</MDBCardText>
                    </MDBCol>
                    <MDBCol sm="9">
                      <MDBCardText className="text-muted">{passengerList?.gender == 1 ? 'Male' : 'Female'}</MDBCardText>
                    </MDBCol>
                  </MDBRow>
                  <hr />
                  <MDBRow>
                    <MDBCol sm="3">
                      <MDBCardText>Date of Birth</MDBCardText>
                    </MDBCol>
                    <MDBCol sm="9">
                      <MDBCardText className="text-muted">{moment(passengerList?.user_dob).format("MM/DD/YYYY")}</MDBCardText>
                    </MDBCol>
                  </MDBRow>
                  <hr />
                  <MDBRow>
                    <MDBCol sm="3">
                      <MDBCardText>Email</MDBCardText>
                    </MDBCol>
                    <MDBCol sm="9">
                      <MDBCardText className="text-muted">{passengerList?.user_email}</MDBCardText>
                    </MDBCol>
                  </MDBRow>
                  <hr />
                  <MDBRow>
                    <MDBCol sm="3">
                      <MDBCardText>Phone</MDBCardText>
                    </MDBCol>
                    <MDBCol sm="9">
                      <MDBCardText className="text-muted">{passengerList?.passenger?.pass_home_phn_no}</MDBCardText>
                    </MDBCol>
                  </MDBRow>
                  <hr />
                  <MDBRow>
                    <MDBCol sm="3">
                      <MDBCardText>Payer</MDBCardText>
                    </MDBCol>
                    <MDBCol sm="9">
                      <MDBCardText className="text-muted">{passengerList?.passenger?.payerDetails?.payer_name}</MDBCardText>
                    </MDBCol>
                  </MDBRow>
                  <hr />
                  <MDBRow>
                    <MDBCol sm="3">
                      <MDBCardText>Address</MDBCardText>
                    </MDBCol>
                    <MDBCol sm="9">
                      <MDBCardText className="text-muted">
                        {[passengerList?.address_1, passengerList?.address_2, passengerList?.city, passengerList?.state_master_lists?.state_name, passengerList?.zip].filter(Boolean).join(', ')}
                      </MDBCardText>
                    </MDBCol>
                  </MDBRow>
                  <hr />
                  <MDBRow>
                    <MDBCol sm="3">
                      <MDBCardText>Visit Frequency</MDBCardText>
                    </MDBCol>
                    <MDBCol sm="9">
                      <MDBCardText className="text-muted">{passengerList?.passenger?.visit_frequency == 2 ? 'One Time' : 'Recurring'}</MDBCardText>
                    </MDBCol>
                  </MDBRow>
                  <hr />
                  <p className='sub-title'>Responsible Party Information</p>
                  <hr />
                  <MDBRow>
                    <MDBCol sm="3">
                      <MDBCardText>Name</MDBCardText>
                    </MDBCol>
                    <MDBCol sm="9">
                      <MDBCardText className="text-muted">{`${passengerList?.passenger?.resp_party_first_name || ''}  ${passengerList?.passenger?.resp_party_last_name || ''}`}</MDBCardText>
                    </MDBCol>
                  </MDBRow>
                  <hr />
                  <MDBRow>
                    <MDBCol sm="3">
                      <MDBCardText>Phone Number</MDBCardText>
                    </MDBCol>
                    <MDBCol sm="9">
                      <MDBCardText className="text-muted">{passengerList?.passenger?.resp_party_phn_no || ''}</MDBCardText>
                    </MDBCol>
                  </MDBRow>
                  <hr />
                  <MDBRow>
                    <MDBCol sm="3">
                      <MDBCardText>Email</MDBCardText>
                    </MDBCol>
                    <MDBCol sm="9">
                      <MDBCardText className="text-muted">{passengerList?.passenger?.resp_party_email || ''}</MDBCardText>
                    </MDBCol>
                  </MDBRow>
                </MDBCardBody>
              </MDBCard>


              <MDBRow style={{ display: 'none' }}>
                <MDBCol md="6">
                  <MDBCard className="mb-4 mb-md-0">
                    <MDBCardBody>
                      <MDBRow>
                        <MDBCol sm="3">
                          <MDBCardText>Full Name</MDBCardText>
                        </MDBCol>
                        <MDBCol sm="9">
                          <MDBCardText className="text-muted">Johnatan Smith</MDBCardText>
                        </MDBCol>
                      </MDBRow>
                      <hr />
                      <MDBRow>
                        <MDBCol sm="3">
                          <MDBCardText>Email</MDBCardText>
                        </MDBCol>
                        <MDBCol sm="9">
                          <MDBCardText className="text-muted">example@example.com</MDBCardText>
                        </MDBCol>
                      </MDBRow>
                      <hr />
                      <MDBRow>
                        <MDBCol sm="3">
                          <MDBCardText>Phone</MDBCardText>
                        </MDBCol>
                        <MDBCol sm="9">
                          <MDBCardText className="text-muted">(097) 234-5678</MDBCardText>
                        </MDBCol>
                      </MDBRow>
                      <hr />
                      <MDBRow>
                        <MDBCol sm="3">
                          <MDBCardText>Mobile</MDBCardText>
                        </MDBCol>
                        <MDBCol sm="9">
                          <MDBCardText className="text-muted">(098) 765-4321</MDBCardText>
                        </MDBCol>
                      </MDBRow>
                      <hr />
                      <MDBRow>
                        <MDBCol sm="3">
                          <MDBCardText>Address</MDBCardText>
                        </MDBCol>
                        <MDBCol sm="9">
                          <MDBCardText className="text-muted">Bay Area, San Francisco, CA</MDBCardText>
                        </MDBCol>
                      </MDBRow>
                    </MDBCardBody>
                  </MDBCard>
                </MDBCol>

                <MDBCol md="6">
                  <MDBCard className="mb-4 mb-md-0">
                    <MDBCardBody>
                      <MDBRow>
                        <MDBCol sm="3">
                          <MDBCardText>Full Name</MDBCardText>
                        </MDBCol>
                        <MDBCol sm="9">
                          <MDBCardText className="text-muted">Johnatan Smith</MDBCardText>
                        </MDBCol>
                      </MDBRow>
                      <hr />
                      <MDBRow>
                        <MDBCol sm="3">
                          <MDBCardText>Email</MDBCardText>
                        </MDBCol>
                        <MDBCol sm="9">
                          <MDBCardText className="text-muted">example@example.com</MDBCardText>
                        </MDBCol>
                      </MDBRow>
                      <hr />
                      <MDBRow>
                        <MDBCol sm="3">
                          <MDBCardText>Phone</MDBCardText>
                        </MDBCol>
                        <MDBCol sm="9">
                          <MDBCardText className="text-muted">(097) 234-5678</MDBCardText>
                        </MDBCol>
                      </MDBRow>
                      <hr />
                      <MDBRow>
                        <MDBCol sm="3">
                          <MDBCardText>Mobile</MDBCardText>
                        </MDBCol>
                        <MDBCol sm="9">
                          <MDBCardText className="text-muted">(098) 765-4321</MDBCardText>
                        </MDBCol>
                      </MDBRow>
                      <hr />
                      <MDBRow>
                        <MDBCol sm="3">
                          <MDBCardText>Address</MDBCardText>
                        </MDBCol>
                        <MDBCol sm="9">
                          <MDBCardText className="text-muted">Bay Area, San Francisco, CA</MDBCardText>
                        </MDBCol>
                      </MDBRow>
                    </MDBCardBody>
                  </MDBCard>
                </MDBCol>
              </MDBRow>
            </MDBCol>
          </MDBRow>
        </MDBContainer>
      </section>
    </div></>
  )
}

export default PassengerProfile